import React from "react";
import { Box, Typography } from "@mui/material";
import BlockIcon from "@mui/icons-material/Block";

import SearchInput from "../../../../components/inputs/SearchInput";
import styles from "./ExportUnitExclusionsHeader.styles";

const ExportUnitExclusionsHeader = ({
  title = "Excluded Units",
  onSearch,
  searchQuery,
  setSearchQuery,
}) => (
  <Box sx={styles.headerRow}>
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <BlockIcon sx={{ ...styles.pageTitle, mr: 1 }} />
      <Typography sx={styles.pageTitle}>{title}</Typography>
    </Box>

    <SearchInput
      value={searchQuery}
      onChange={setSearchQuery}
      onSearch={onSearch}
      placeholder="Search unit or date..."
    />
  </Box>
);

export default ExportUnitExclusionsHeader;
